var _style, _path, _defs, _g, _path2, _defs2, _g2, _path3, _defs3, _g3, _path4, _defs4, _g4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerfectaEnergiaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 691 370.1",
    style: {
      enableBackground: "new 0 0 691 370.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{clip-path:url(#SVGID_2_);}\r\n\t.st2{clip-path:url(#SVGID_4_);}\r\n\t.st3{clip-path:url(#SVGID_6_);}\r\n\t.st4{clip-path:url(#SVGID_8_);}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st6{fill:url(#SVGID_9_);stroke:#2C8FFF;stroke-width:1.3407;stroke-miterlimit:10;}\r\n\t.st7{fill:url(#SVGID_10_);stroke:#2C8FFF;stroke-width:1.3407;stroke-miterlimit:10;}\r\n\t.st8{fill:url(#SVGID_11_);stroke:#2C8FFF;stroke-width:1.3407;stroke-miterlimit:10;}\r\n\t.st9{fill:url(#SVGID_12_);stroke:#2C8FFF;stroke-width:1.3407;stroke-miterlimit:10;}\r\n\t.st10{fill:#FDFDFD;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Camada_1_1_"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.8,179.7c13.5,0,24.5-11,24.5-24.5c0-13.5-11-24.5-24.5-24.5V179.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M61.8,179.7c13.5,0,24.5-11,24.5-24.5c0-13.5-11-24.5-24.5-24.5V179.7z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 179.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 179.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 179.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 178.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 178.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 178.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 178.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 178,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 177.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 177.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 177.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 177.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 176.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 176.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 176.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 176.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 176,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 175.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 175.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 175.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 175.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 174.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 174.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 174.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 174.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 174,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 173.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 173.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 173.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 173.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 172.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 172.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 172.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 172.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 172.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 171.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 171.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 171.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 171.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 171,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 170.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 170.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 170.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 170.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 169.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 169.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 169.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 169.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 169,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 168.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 168.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 168.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 168.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 167.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 167.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 167.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 167.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 167,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 166.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 166.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 166.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 166.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 165.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 165.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 165.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 165.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 165.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 164.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 164.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 164.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 164.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 164,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 163.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 163.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 163.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 163.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 162.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 162.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 162.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 162.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 162,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 161.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 161.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 161.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 161.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 160.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 160.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 160.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 160.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 160,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 159.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 159.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 159.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 159.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 158.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 158.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 158.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 158.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 158,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 157.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 157.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 157.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 157.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 156.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 156.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 156.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 156.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 156.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 155.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 155.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 155.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 155.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 155,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 154.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 154.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 154.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 154.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 153.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 153.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 153.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 153.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 153,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 152.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 152.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 152.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 152.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 151.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 151.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 151.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 151.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 151,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 150.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 150.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 150.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 150.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 149.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 149.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 149.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 149.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 149.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 148.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 148.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 148.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 148.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 148,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 147.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 147.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 147.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 147.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 146.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 146.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 146.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 146.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 146,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 145.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 145.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 145.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 145.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 144.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 144.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 144.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 144.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 144,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 143.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 143.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 143.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 143.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 142.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 142.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 142.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 142.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 142.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 141.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 141.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 141.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 141.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 141,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 140.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 140.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 140.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 140.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 139.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 139.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 139.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 139.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 139,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 138.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 138.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 138.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 138.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 137.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 137.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 137.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 137.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 137,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 136.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 136.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 136.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 136.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 135.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 135.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 135.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 135.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 135,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 134.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 134.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 134.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 134.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 134,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 133.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 133.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 133.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 133.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 132.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 132.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 132.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 132.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 132,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 131.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 131.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 131.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 131.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 130.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 130.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.8,154.3c-13.5,0-24.5,11-24.5,24.5s11,24.5,24.5,24.5V154.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M61.8,154.3c-13.5,0-24.5,11-24.5,24.5s11,24.5,24.5,24.5V154.3z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 203.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 202.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 202.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 202.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 202.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 202,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 201.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 201.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 201.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 201.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 200.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 200.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 200.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 200.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 200.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 199.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 199.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 199.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 199.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 199,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 198.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 198.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 198.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 198.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 197.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 197.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 197.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 197.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 197,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 196.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 196.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 196.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 196.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 195.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 195.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 195.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 195.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 195,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 194.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 194.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 194.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 194.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 193.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 193.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 193.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 193.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 193.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 192.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 192.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 192.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 192.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 192,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 191.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 191.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 191.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 191.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 190.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 190.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 190.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 190.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 190,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 189.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 189.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 189.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 189.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 188.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 188.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 188.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 188.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 188,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 187.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 187.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 187.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 187.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 186.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 186.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 186.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 186.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 186,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 185.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 185.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 185.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 185.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 185,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 184.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 184.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 184.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 184.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 183.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 183.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 183.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 183.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 183,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 182.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 182.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 182.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 182.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 181.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 181.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 181.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 181.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 181,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 180.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 180.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 180.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 180.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 179.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 179.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 179.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 179.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 179,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 178.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 178.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 178.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 178.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 177.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 177.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 177.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 177.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 177.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 176.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 176.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 176.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 176.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 176,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 175.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 175.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 175.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 175.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 174.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 174.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 174.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 174.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 174,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 173.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 173.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 173.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 173.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 172.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 172.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 172.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 172.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 172,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 171.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 171.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 171.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 171.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 170.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 170.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 170.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 170.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 170.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 169.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 169.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 169.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 169.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 169,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 168.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 168.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 168.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 168.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 167.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 167.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 167.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 167.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 167,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 166.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 166.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 166.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 166.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 165.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 165.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 165.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 165.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 165,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 164.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 164.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 164.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 164.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 163.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 163.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 163.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 163.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 163.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 162.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 162.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 162.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 162.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 162,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 161.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 161.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 161.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 161.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 160.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 160.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 160.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 160.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 160,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 159.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 159.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 159.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 159.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 158.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 158.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 158.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 158.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 158,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 157.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 157.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 157.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 157.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 156.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 156.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 156.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 156.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 156,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 155.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 155.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 155.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 155.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 155,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 154.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 154.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 154.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.9,155.2c-13.5,0-24.5,11-24.5,24.5c0,13.5,11,24.5,24.5,24.5V155.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M107.9,155.2c-13.5,0-24.5,11-24.5,24.5c0,13.5,11,24.5,24.5,24.5V155.2z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 204,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 203.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 203.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 203.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 203.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 202.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 202.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 202.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 202.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 202.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 201.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 201.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 201.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 201.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 201,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 200.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 200.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 200.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 200.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 199.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 199.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 199.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 199.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 199,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 198.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 198.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 198.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 198.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 197.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 197.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 197.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 197.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 197,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 196.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 196.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 196.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 196.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 195.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 195.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 195.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 195.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 195.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 194.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 194.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 194.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 194.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 194,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 193.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 193.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 193.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 193.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 192.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 192.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 192.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 192.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 192,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 191.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 191.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 191.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 191.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 190.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 190.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 190.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 190.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 190,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 189.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 189.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 189.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 189.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 188.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 188.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 188.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 188.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 188,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 187.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 187.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 187.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 187.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 186.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 186.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 186.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 186.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 186.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 185.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 185.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 185.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 185.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 185,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 184.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 184.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 184.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 184.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 183.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 183.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 183.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 183.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 183,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 182.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 182.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 182.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 182.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 181.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 181.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 181.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 181.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 181,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 180.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 180.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 180.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 180.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 179.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 179.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 179.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 179.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 179.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 178.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 178.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 178.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 178.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 178,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 177.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 177.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 177.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 177.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 176.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 176.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 176.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 176.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 176,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 175.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 175.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 175.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 175.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 174.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 174.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 174.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 174.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 174,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 173.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 173.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 173.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 173.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 172.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 172.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 172.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 172.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 172.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 171.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 171.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 171.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 171.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 171,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 170.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 170.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 170.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 170.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 169.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 169.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 169.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 169.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 169,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 168.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 168.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 168.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 168.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 167.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 167.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 167.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 167.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 167,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 166.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 166.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 166.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 166.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 165.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 165.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 165.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 165.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 165.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 164.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 164.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 164.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 164.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 164,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 163.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 163.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 163.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 163.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 162.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 162.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 162.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 162.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 162,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 161.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 161.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 161.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 161.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 160.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 160.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 160.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 160.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 160,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 159.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 159.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 159.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 159.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 158.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 158.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 158.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 158.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 158,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 157.8,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 157.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 157.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 157.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 156.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 156.7,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 156.5,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 156.3,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 156.1,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 155.9,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 155.6,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 155.4,
    className: "st0",
    width: 24.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 155.2,
    className: "st0",
    width: 24.5,
    height: 0.2
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.4,179.7c0-13.5-11-24.5-24.5-24.5v24.5H132.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M132.4,179.7c0-13.5-11-24.5-24.5-24.5v24.5H132.4z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 179.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 179.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 179.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 179.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 179.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 179.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 179,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 178.8,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 178.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 178.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 178.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 178.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 178.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 178.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 178.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 178,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 177.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 177.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 177.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 177.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 177.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 177.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 177.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 177.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 177,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 176.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 176.8,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 176.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 176.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 176.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 176.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 176.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 176.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 176,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 175.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 175.8,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 175.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 175.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 175.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 175.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 175.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 175.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 175,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 174.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 174.8,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 174.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 174.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 174.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 174.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 174.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 174.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 174,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 173.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 173.8,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 173.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 173.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 173.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 173.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 173.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 173.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 173,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 172.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 172.8,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 172.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 172.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 172.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 172.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 172.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 172.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 172.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 171.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 171.8,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 171.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 171.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 171.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 171.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 171.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 171.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 171.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 171,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 170.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 170.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 170.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 170.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 170.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 170.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 170.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 170.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 170,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 169.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 169.8,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 169.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 169.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 169.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 169.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 169.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 169.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 169,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 168.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 168.8,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 168.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 168.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 168.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 168.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 168.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 168.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 168,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 167.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 167.8,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 167.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 167.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 167.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 167.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 167.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 167.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 167,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 166.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 166.8,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 166.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 166.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 166.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 166.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 166.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 166.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 166,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 165.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 165.8,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 165.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 165.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 165.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 165.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 165.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 165.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 165.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 164.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 164.8,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 164.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 164.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 164.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 164.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 164.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 164.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 164.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 164,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 163.8,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 163.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 163.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 163.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 163.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 163.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 163.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 163.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 163,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 162.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 162.8,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 162.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 162.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 162.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 162.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 162.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 162.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 162,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 161.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 161.8,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 161.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 161.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 161.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 161.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 161.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 161.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 161,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 160.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 160.8,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 160.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 160.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 160.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 160.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 160.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 160.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 160,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 159.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 159.8,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 159.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 159.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 159.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 159.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 159.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 159.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 159,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 158.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 158.8,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 158.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 158.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 158.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 158.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 158.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 158.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 158,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 157.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 157.8,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 157.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 157.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 157.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 157.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 157.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 157.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 157.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 156.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 156.8,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 156.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 156.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 156.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 156.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 156.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 156.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 156.1,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 156,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 155.9,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 155.7,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 155.6,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 155.5,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 155.4,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 155.3,
    className: "st0",
    width: 24.5,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 155.2,
    className: "st0",
    width: 24.5,
    height: 0.1
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231.5,176.1c0.8-2.2,2.2-3.8,4.1-4.9c1.9-1.1,4-1.6,6.3-1.6v9.8c-2.7-0.3-5.1,0.2-7.2,1.6 c-2.1,1.4-3.2,3.8-3.2,7v16.3h-8.8v-34.2h8.8V176.1L231.5,176.1L231.5,176.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M265.3,164.1c-4.8-0.4-7.2,1.6-7.2,5.8v0.3h7.2v8.5h-7.2v25.7h-8.8v-25.7h-4.9v-8.5h4.9v-0.3 c0-4.8,1.3-8.5,4-11s6.7-3.6,12-3.3V164.1L265.3,164.1L265.3,164.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.1,190.9c1.2,4.3,4.4,6.4,9.6,6.4c3.4,0,5.9-1.1,7.7-3.4l7.1,4.1c-3.4,4.9-8.3,7.3-14.9,7.3 c-5.7,0-10.2-1.7-13.6-5.1c-3.4-3.4-5.1-7.7-5.1-12.9c0-5.2,1.7-9.4,5.1-12.9s7.7-5.2,13-5.2c5,0,9.1,1.7,12.4,5.2 c3.3,3.5,4.9,7.7,4.9,12.8c0,1.1-0.1,2.3-0.3,3.6L276.1,190.9L276.1,190.9z M275.9,184.1h17.4c-0.5-2.3-1.5-4.1-3.1-5.2 c-1.6-1.1-3.4-1.7-5.4-1.7c-2.4,0-4.3,0.6-5.9,1.8S276.4,181.9,275.9,184.1L275.9,184.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323.7,205.4c-5.2,0-9.4-1.7-12.9-5.2c-3.4-3.5-5.2-7.7-5.2-12.8c0-5.1,1.7-9.4,5.2-12.8 c3.4-3.5,7.7-5.2,12.9-5.2c3.3,0,6.4,0.8,9.1,2.4c2.7,1.6,4.8,3.7,6.2,6.4l-7.6,4.4c-0.7-1.4-1.7-2.5-3.1-3.4 c-1.4-0.8-3-1.2-4.7-1.2c-2.6,0-4.8,0.9-6.6,2.6c-1.7,1.8-2.6,4-2.6,6.7s0.9,4.9,2.6,6.7c1.7,1.8,3.9,2.6,6.6,2.6 c1.8,0,3.4-0.4,4.8-1.2c1.4-0.8,2.4-1.9,3.1-3.3l7.7,4.4c-1.5,2.7-3.6,4.8-6.4,6.5C330,204.5,327,205.3,323.7,205.4L323.7,205.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363.7,178.7H356v14.2c0,1.2,0.3,2.1,0.9,2.6c0.6,0.5,1.5,0.9,2.6,0.9c1.1,0.1,2.6,0.1,4.2,0v8 c-6.1,0.7-10.3,0.1-12.8-1.7s-3.7-5.1-3.7-9.8v-14.2h-5.9v-8.5h5.9v-6.9l8.8-2.7v9.6h7.7L363.7,178.7L363.7,178.7L363.7,178.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M394.8,170.2h8.8v34.2h-8.8v-4c-2.6,3.3-6.4,5-11.1,5c-4.8,0-8.5-1.7-11.7-5.2c-3.3-3.5-4.9-7.8-4.9-12.8 c0-5.1,1.6-9.3,4.9-12.8c3.3-3.5,7.2-5.2,11.7-5.2c4.8,0,8.5,1.7,11.1,5V170.2L394.8,170.2L394.8,170.2z M378.5,194.3 c1.8,1.8,4,2.7,6.8,2.7c2.7,0,5-0.9,6.8-2.7s2.7-4.1,2.7-6.9s-0.9-5.1-2.7-6.9c-1.8-1.8-4.1-2.7-6.8-2.7c-2.7,0-5,0.9-6.8,2.7 c-1.8,1.8-2.7,4.1-2.7,6.9S376.8,192.5,378.5,194.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.3,190.9c1.2,4.3,4.4,6.4,9.6,6.4c3.4,0,5.9-1.1,7.7-3.4l7.1,4.1c-3.4,4.9-8.3,7.3-14.9,7.3 c-5.7,0-10.2-1.7-13.6-5.1c-3.4-3.4-5.1-7.7-5.1-12.9c0-5.2,1.7-9.4,5.1-12.9s7.7-5.2,13-5.2c5,0,9.1,1.7,12.4,5.2 s4.9,7.7,4.9,12.8c0,1.1-0.1,2.3-0.3,3.6L191.3,190.9L191.3,190.9z M191.2,184.1h17.4c-0.5-2.3-1.5-4.1-3.1-5.2 c-1.6-1.1-3.4-1.7-5.4-1.7c-2.4,0-4.3,0.6-5.9,1.8C192.7,180.2,191.7,181.9,191.2,184.1L191.2,184.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.6,161.2c-3.1-3.1-7-4.6-11.6-4.6h-17.8v8.8H164c2,0,3.7,0.7,5,2.1s2,3.1,2,5.2c0,2.1-0.7,3.8-2,5.2 c-1.3,1.4-3,2.1-5,2.1h-17.8v24.5h9.4v-15.7h8.4c4.6,0,8.5-1.5,11.6-4.6c3.1-3.1,4.7-6.9,4.7-11.4S178.8,164.3,175.6,161.2 L175.6,161.2L175.6,161.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255,230.9c-0.1-0.4-0.1-0.8-0.1-1.2c0-1.7,0.7-3.3,1.9-4.5c1.2-1.2,2.8-1.9,4.5-1.9v2.4 c-1.1,0-2.1,0.4-2.8,1.2c-0.7,0.8-1.2,1.8-1.2,2.8c0,0.4,0.1,0.8,0.2,1.2L255,230.9L255,230.9z M261.2,228.5v2.4h3.8 c-0.3,0.8-0.8,1.5-1.4,2c-0.7,0.5-1.5,0.8-2.4,0.8v2.4c0.8,0,1.7-0.2,2.4-0.5c0.8-0.3,1.5-0.8,2.1-1.4c0.6-0.6,1.1-1.3,1.4-2.1 c0.3-0.8,0.5-1.6,0.5-2.4v-1.2L261.2,228.5L261.2,228.5L261.2,228.5z M271.6,226.1h-2.5v9.7h2.5v-4.6c0-0.9,0.3-1.6,0.9-2 c0.6-0.4,1.3-0.6,2-0.5v-2.8c-0.7,0-1.3,0.2-1.8,0.5c-0.5,0.3-0.9,0.8-1.2,1.4V226.1L271.6,226.1L271.6,226.1z M285.1,232 c0.1-0.4,0.1-0.7,0.1-1c0-1.4-0.5-2.7-1.4-3.6s-2.1-1.5-3.5-1.5c-1.5,0-2.7,0.5-3.7,1.5c-1,1-1.4,2.2-1.4,3.7s0.5,2.7,1.5,3.7 s2.3,1.5,3.9,1.5c1.9,0,3.3-0.7,4.2-2.1l-2-1.2c-0.5,0.6-1.2,1-2.2,1c-1.5,0-2.4-0.6-2.7-1.8L285.1,232L285.1,232L285.1,232z  M278.6,228.6c0.4-0.3,1-0.5,1.7-0.5c0.6,0,1.1,0.2,1.5,0.5c0.4,0.3,0.7,0.8,0.9,1.5h-4.9C277.9,229.4,278.1,229,278.6,228.6 L278.6,228.6L278.6,228.6z M296.1,232c0.1-0.4,0.1-0.7,0.1-1c0-1.4-0.5-2.7-1.4-3.6c-0.9-1-2.1-1.5-3.5-1.5c-1.5,0-2.7,0.5-3.7,1.5 s-1.4,2.2-1.4,3.7s0.5,2.7,1.5,3.7c1,1,2.3,1.5,3.9,1.5c1.9,0,3.3-0.7,4.2-2.1l-2-1.2c-0.5,0.6-1.2,1-2.2,1c-1.5,0-2.4-0.6-2.7-1.8 L296.1,232L296.1,232L296.1,232z M289.6,228.6c0.4-0.3,1-0.5,1.7-0.5c0.6,0,1.1,0.2,1.5,0.5c0.4,0.3,0.7,0.8,0.9,1.5h-4.9 C288.8,229.4,289.1,229,289.6,228.6L289.6,228.6L289.6,228.6z M300.1,227.2v-1.1h-2.5v9.7h2.5v-5.2c0-0.8,0.2-1.4,0.6-1.8 c0.4-0.4,0.9-0.6,1.5-0.6c0.6,0,1,0.2,1.4,0.5c0.4,0.3,0.5,0.8,0.5,1.5v5.6h2.5v-6c0-1.3-0.3-2.2-1-2.9c-0.7-0.7-1.6-1.1-2.6-1.1 C301.7,225.9,300.7,226.3,300.1,227.2L300.1,227.2L300.1,227.2z M312.2,232.9l-2.3-6.8h-2.8l3.7,9.7h2.8l3.7-9.7h-2.8L312.2,232.9 L312.2,232.9z M327.5,231c0-1.4-0.5-2.6-1.5-3.6c-1-1-2.2-1.5-3.6-1.5c-1.4,0-2.6,0.5-3.6,1.5s-1.5,2.2-1.5,3.6s0.5,2.6,1.5,3.6 s2.2,1.5,3.6,1.5c1.4,0,2.6-0.5,3.6-1.5C327.1,233.6,327.5,232.4,327.5,231z M319.8,231c0-0.8,0.2-1.4,0.7-1.9 c0.5-0.5,1.1-0.8,1.9-0.8c0.8,0,1.4,0.3,1.9,0.8s0.8,1.1,0.8,1.9c0,0.8-0.3,1.4-0.8,1.9s-1.1,0.8-1.9,0.8c-0.8,0-1.4-0.3-1.9-0.8 S319.8,231.7,319.8,231z M331.5,235.8v-14.1H329v14.1H331.5z M339.1,226.1h-2.2v-2.7l-2.5,0.8v2h-1.7v2.4h1.7v4 c0,1.3,0.4,2.3,1.1,2.8s1.9,0.7,3.6,0.5v-2.3c-0.5,0-0.9,0-1.2,0c-0.3,0-0.6-0.1-0.7-0.3c-0.2-0.2-0.3-0.4-0.3-0.7v-4h2.2 L339.1,226.1L339.1,226.1L339.1,226.1z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.2,230.8c0,2.9-2.1,5.1-4.6,5.1c-1.3,0-2.2-0.4-2.9-1.2v4.7h-2.9V226h2.9v0.9c0.6-0.7,1.6-1.2,2.9-1.2 C154.2,225.7,156.2,228,156.2,230.8L156.2,230.8z M153.4,230.8c0-1.4-1-2.3-2.3-2.3s-2.3,0.9-2.3,2.3s1,2.3,2.3,2.3 S153.4,232.2,153.4,230.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.4,230.8c0-2.9,2.3-5.1,5.1-5.1c2.8,0,5.1,2.2,5.1,5.1c0,2.9-2.3,5.1-5.1,5.1 C159.7,235.9,157.4,233.7,157.4,230.8z M164.7,230.8c0-1.4-1-2.3-2.2-2.3s-2.2,0.9-2.2,2.3s1,2.3,2.2,2.3 S164.7,232.2,164.7,230.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.1,226l-3.1,9.6h-2.7l-1.5-5.1l-1.5,5.1h-2.7l-3.1-9.6h3.1l1.4,5.1l1.5-5.1h2.7l1.5,5.1l1.4-5.1H182.1 L182.1,226z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.1,233.3c0.8,0,1.5-0.3,1.8-0.7l2.3,1.3c-0.9,1.3-2.4,2-4.2,2c-3.3,0-5.3-2.2-5.3-5.1 c0-2.9,2.1-5.1,5.1-5.1c2.8,0,4.9,2.2,4.9,5.1c0,0.4,0,0.8-0.1,1.1h-6.8C186.2,233,187.1,233.3,188.1,233.3L188.1,233.3z  M189.9,229.8c-0.3-1.1-1.2-1.5-2-1.5c-1.1,0-1.8,0.5-2.1,1.5H189.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.1,225.8v3.3c-1.2-0.2-2.9,0.3-2.9,2.2v4.3h-2.9V226h2.9v1.7C197.6,226.4,198.9,225.8,200.1,225.8 L200.1,225.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.7,233.3c0.8,0,1.5-0.3,1.8-0.7l2.3,1.3c-0.9,1.3-2.4,2-4.2,2c-3.3,0-5.3-2.2-5.3-5.1 c0-2.9,2.1-5.1,5.1-5.1c2.8,0,4.9,2.2,4.9,5.1c0,0.4,0,0.8-0.1,1.1h-6.8C203.8,233,204.7,233.3,205.7,233.3L205.7,233.3z  M207.5,229.8c-0.3-1.1-1.2-1.5-2-1.5c-1.1,0-1.8,0.5-2.1,1.5H207.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M221.7,222.2v13.4h-2.9v-0.9c-0.6,0.7-1.6,1.2-2.9,1.2c-2.5,0-4.6-2.2-4.6-5.1c0-2.9,2.1-5.1,4.6-5.1 c1.3,0,2.2,0.4,2.9,1.2v-4.7L221.7,222.2L221.7,222.2z M218.8,230.8c0-1.4-1-2.3-2.3-2.3s-2.3,0.9-2.3,2.3s1,2.3,2.3,2.3 S218.8,232.2,218.8,230.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239,230.8c0,2.9-2.1,5.1-4.6,5.1c-1.3,0-2.2-0.4-2.9-1.2v0.9h-2.9v-13.4h2.9v4.7c0.6-0.7,1.6-1.2,2.9-1.2 C236.9,225.7,239,228,239,230.8L239,230.8z M236.1,230.8c0-1.4-1-2.3-2.3-2.3s-2.3,0.9-2.3,2.3s1,2.3,2.3,2.3 S236.1,232.2,236.1,230.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.4,226l-3.3,9.3c-1.1,3-2.8,4.2-5.5,4.1v-2.7c1.3,0,2-0.4,2.4-1.6l-3.8-9.1h3.2l2.1,5.9l1.8-5.9H249.4 L249.4,226z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M428.6,201.9h24.2v3.5h-27.9v-48.4h27.5v3.5h-23.9v18.8h22.1v3.5h-22.1V201.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M476.9,170c4.1,0,7.4,1.3,9.8,3.8c2.4,2.5,3.6,5.9,3.6,10.1v21.5h-3.5v-21.5c0-3.2-0.9-5.8-2.7-7.7 c-1.8-1.9-4.3-2.8-7.5-2.8c-3.6,0-6.5,1.2-8.7,3.5c-2.3,2.4-3.4,5.8-3.4,10.2v18.3h-3.5v-34.6h3.5v6.6 C467,172.4,471.2,170,476.9,170L476.9,170z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M515.7,170c5.1,0,9.2,1.8,12.3,5.4c3.2,3.6,4.7,7.9,4.7,12.8c0,0.2,0,0.5,0,0.8c0,0.4,0,0.6,0,0.8h-31.3 c0.4,3.9,2,7,4.7,9.4c2.7,2.4,6,3.6,10,3.6c2.8,0,5.2-0.6,7.3-1.7c2.1-1.1,3.6-2.7,4.7-4.6l3,1.8c-1.4,2.4-3.5,4.3-6.1,5.7 c-2.6,1.4-5.6,2.1-9,2.1c-5.3,0-9.7-1.7-13.1-5.1c-3.4-3.4-5.1-7.7-5.1-13s1.7-9.5,5-12.9C506.1,171.7,510.4,170,515.7,170 L515.7,170z M515.7,173.3c-3.9,0-7.2,1.2-9.8,3.7s-4.1,5.6-4.5,9.5h27.8c-0.4-4.1-1.8-7.3-4.4-9.7 C522.2,174.5,519.2,173.3,515.7,173.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M544.3,177.5c2.1-4.8,5.9-7.3,11.6-7.3v3.3c-3.3,0-6,1.1-8.2,3.1c-2.2,2.1-3.3,5.2-3.3,9.4v19.2h-3.5v-34.6 h3.5V177.5L544.3,177.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M591.5,170.8h3.5v32.9c0,5-1.6,9-4.9,11.9c-3.3,2.9-7.4,4.4-12.3,4.4c-4,0-7.4-0.7-10.2-2.2 s-4.9-3.5-6.2-6.1l3-1.7c2.2,4.5,6.6,6.7,13.3,6.7c4.3,0,7.7-1.2,10.1-3.5c2.4-2.3,3.7-5.5,3.7-9.4v-6.4 c-1.4,2.7-3.4,4.9-6.1,6.4s-5.5,2.4-8.8,2.4c-5,0-9.2-1.7-12.7-5.2c-3.5-3.5-5.2-7.8-5.2-12.8c0-5.1,1.7-9.4,5.2-12.8 c3.5-3.5,7.7-5.2,12.7-5.2c3.3,0,6.2,0.8,8.8,2.4c2.6,1.6,4.6,3.7,6.1,6.4L591.5,170.8L591.5,170.8z M566.4,198.5 c2.8,2.9,6.3,4.3,10.4,4.3s7.6-1.4,10.4-4.3c2.8-2.9,4.3-6.3,4.3-10.4s-1.4-7.6-4.3-10.4c-2.8-2.9-6.3-4.3-10.4-4.3 s-7.6,1.4-10.4,4.3c-2.8,2.9-4.3,6.3-4.3,10.4S563.6,195.7,566.4,198.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M609.3,157.1h4.2l-4.6,8.8h-3.4L609.3,157.1z M609.1,205.4v-34.6h-3.5v34.6H609.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M650.1,170.8h3.5v34.6h-3.5v-7.8c-1.5,2.7-3.5,4.8-6.1,6.3c-2.6,1.5-5.5,2.3-8.8,2.3 c-4.9,0-9.2-1.7-12.7-5.2c-3.5-3.5-5.3-7.8-5.3-12.8s1.8-9.4,5.3-12.8c3.5-3.5,7.7-5.2,12.7-5.2c3.3,0,6.2,0.8,8.8,2.3 c2.6,1.5,4.6,3.6,6.1,6.3V170.8L650.1,170.8z M625.1,198.5c2.8,2.9,6.3,4.3,10.4,4.3s7.6-1.4,10.4-4.3c2.8-2.9,4.2-6.3,4.2-10.4 s-1.4-7.6-4.2-10.4c-2.8-2.9-6.3-4.3-10.4-4.3s-7.6,1.4-10.4,4.3c-2.8,2.9-4.3,6.3-4.3,10.4S622.3,195.7,625.1,198.5z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfectaEnergiaLogo);
export default __webpack_public_path__ + "static/media/PerfectaEnergiaLogo.79c93016dfe960222a92ee4fd524c30a.svg";
export { ForwardRef as ReactComponent };